import { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ConnectComponentsProvider } from '@stripe/react-connect-js';
import { useStripeExpress } from 'customHooks/useStripeExpress';

interface StripeConnectProviderProps {
    children: ReactNode;
}

const ErrorFallback = () => (
    <div className="flex flex-col items-center justify-center gap-2">
        <h1 className={'text-2xl font-medium'}>Unable to connect to Stripe</h1>
        <p className={'text-center'}>Please try back again in a few minutes.</p>
    </div>
);

const StripeConnectContent = ({ children }: StripeConnectProviderProps) => {
    const stripeConnectInstance = useStripeExpress();

    return (
        <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
            {children}
        </ConnectComponentsProvider>
    );
};

const StripeExpressProvider = ({ children }: StripeConnectProviderProps) => {
    return (
        <ErrorBoundary fallback={<ErrorFallback />}>
            <StripeConnectContent>{children}</StripeConnectContent>
        </ErrorBoundary>
    );
};

export { StripeExpressProvider };
